// extracted by mini-css-extract-plugin
export default {"borderTop":"IssueRefundDialog--borderTop--c42c36","note":"IssueRefundDialog--note--0045eb"};